<template>
  <Modal class="my-modal" v-model="visible" title="选择底图生成封面" :footer-hide="true" :mask-closable="false" width="80%">
    <div class="cover-wrap">
      <div class="img-box" :class="{ 'sel': img.coverUrl === selImg.coverUrl }" v-for="img in productCoverList"
        :key="img.id">
        <img :src="img.coverUrl" :alt="img.coverName" @click="sel(img)">
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: [],
  data() {
    return {
      key: "",
      selImg: {},
      visible: false,
      productCoverList:[],
    };
  },
  methods: {
    sel(img) {
      img.key = this.key;
      this.selImg = img;
      this.$emit('success', this.selImg);
      setTimeout(() => {
        this.visible = false;
      }, 200)
    },
    async open(key, coverUrl = '') {
      this.key = key;
      this.selImg = {
        coverUrl
      }
      const close = this.$notice.loading('加载中');
      await this.getProductCover();
      close();
      this.visible = true;
    },
    // 获取系统内置产品图
    getProductCover() {
      this.$http({
        url: '/buz/productCoverLibrary/read/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(async res => {
        if (res.data) {
          this.productCoverList = res.data;
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-modal-body {
  padding: 16px 0 16px 16px;
}

.cover-wrap {
  max-height: 70vh;
  display: flex;
  flex-wrap: wrap;
  overflow: scroll;

  .img-box {
    flex: 0 0 200px;
    width: 200px;
    height: 200px;
    margin: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 196px;
      height: 196px;
    }
  }

  .sel {
    border: 2px solid #236DFF;
  }
}
</style>
